module.exports = __webpack_public_path__ + "assets/img/3.98b10019.png";